import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from 'src/app/shared/models/TranslationRequest';

@Component({
  selector: 'app-pwinstructions',
  template: ` <div class="toast-info width-full app-p2 tw-rounded-lg">
    <span
      class="tw-block tw-mb-4 tw-text-[var(--sed-engaged-black-color)]"
      tabindex="0"
    >
      {{ 'Your new password must have the following characteristics:' | translation : translationRequest }}
    </span>
    <ul class=" tw-text-[var(--sed-engaged-black-color)]">
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        {{ 'Be 8-16 characters long.' | translation : translationRequest }}
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        {{ 'Contain at least one letter and one number.' | translation : translationRequest }}
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        {{ 'Contain at least one uppercase and one lowercase letter.' | translation : translationRequest }}
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        {{ 'Must contain only one of the following special characters ' | translation : translationRequest }}{{'@#$%^&+=!'}}
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        <span>{{ 'Must not contain your user name.' | translation : translationRequest }}</span>
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        <span>{{ 'Be different from your current password and previous 12 passwords.' | translation : translationRequest }}</span>
      </li>
      <li class="tw-flex tw-items-center" tabindex="0">
        <mat-icon class="app-pr5">info</mat-icon>
        <span>{{ 'Not be a password used within the last 90 days.' | translation : translationRequest }}</span>
      </li>
    </ul>
  </div>`,
  styles: [
    `
      @media screen and (min-width: 250px) and (max-width: 560px) {
        .width-full {
          width: 100%;
        }
      }
      .toast-info {
        color: var(--sed-warm-white-color) !important;
        background-color: var(--sed-purple-40-color) !important;
      }
      li:focus {
        outline: 2px solid var(--sed-engaged-black-color) !important;
        outline-offset: 2px;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
      }
    `,
  ],
})
export class PwinstructionsComponent implements OnInit {
  translationRequest: TranslationRequest;

  constructor() {
    // Initialize translation request with appropriate context
    this.translationRequest = new TranslationRequest({
      language: sessionStorage.getItem('languagepreference') || 'en',
      group: 'Shared', // Group for password-related translations
      subGroup: 'Shared', // Subgroup for password instructions
      key: '',
      contNum: 0,
      tableName: '',
      primaryKey: '',
      primaryValue: '',
      lob: ''
    });
  }

  ngOnInit(): void {}
}
